import React from 'react';
import {Routes, Route} from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { RegionProvider } from './context/RegionContext';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Cart from './components/cart/Cart';
import ScrollToTop from './components/common/ScrollToTop';
import HomePage from './pages/HomePage';
import ProductsPage from './pages/ProductsPage';
import ShopPage from './pages/ShopPage';
import ContactPage from './pages/ContactPage';
import ProductDetailPage from './pages/ProductDetailPage';
import CheckoutPage from './pages/CheckoutPage';
import OrderConfirmationPage from './pages/OrderConfirmationPage';
import StoreLocations from './pages/StoreLocations';
import ShippingInfo from './pages/ShippingInfo';
import ReturnsExchanges from './pages/ReturnsExchanges';
import FAQ from './pages/FAQ';
import WarrantyInfo from './pages/WarrantyInfo';
import AboutUs from './pages/AboutUs';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';

function App() {
  return (
    <RegionProvider>
      <CartProvider>
        <ScrollToTop />
        
        <div className="App min-h-screen flex flex-col">
          <Header />  
          <div className="flex-1">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/products" element={<ProductsPage />} />
              <Route path="/shop" element={<ShopPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/product/:productId" element={<ProductDetailPage />} />
              <Route path="/checkout" element={<CheckoutPage />} />
              <Route path="/order-confirmation/:orderNumber" element={<OrderConfirmationPage />} />
              <Route path="/locations" element={<StoreLocations />} />
              <Route path="/shipping" element={<ShippingInfo />} />
              <Route path="/returns" element={<ReturnsExchanges />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/warranty" element={<WarrantyInfo />} />
              <Route path="/about" element={<AboutUs />} />
              <Route path='/blog' element={<BlogPage />} />
              <Route path="/blog/:slug" element={<BlogPostPage />} />
              <Route path="*" element={<HomePage />} />
            </Routes>
          </div>

          <Footer />
          <Cart />
        </div>
      </CartProvider>
    </RegionProvider>
  );
}

export default App;
